export default {
    name: 'routing',
};
